import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";

interface SocialChange {
  heading: string;
  image: string;
  video: string;
}

const SuccessStories: React.FC = React.memo(() => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState<SocialChange | null>(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_LOCAL_URL}/api/social-changes`
        );

        if (response.data.status === "success") {
          setData(response.data.message[2]);
        }
      } catch (error) {
        console.error("Error fetching social changes:", error);
      }
    };
    fetchData();
  }, []);

  // Memoized processed image URL
  const imageUrl = useMemo(
    () => (data?.image ? `${process.env.REACT_APP_LOCAL_URL}/${data.image.replace(/\\/g, "/")}` : ""),
    [data?.image]
  );

  if (!data) {
    return (
      <section className="py-20 text-center text-gray-500">
        Loading success story...
      </section>
    );
  }

  return (
    <div>
      <section className="gsap-fade-in w-container">
        <div className="md:flex items-end justify-between border-b pb-3 border-[#84848480]">
          <h1 className="font-lato-bold text-[#07393C]">{data.heading}</h1>
        </div>

        <div className="blade-top-margin-sm relative overflow-hidden">
          <img
            src={imageUrl}
            className="2xl:min-h-[600px] xl:min-h-[500px] lg:min-h-[450px] min-h-[300px] w-full bg-[#22574D] object-cover object-center"
            alt="Buddha Fellow"
          />
          <img
            src="/BudhaFellowProgram/video-icon.png"
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 2xl:h-28 2xl:w-28 h-20 w-20 cursor-pointer"
            onClick={openModal}
            alt="play button"
          />
        </div>
      </section>

      {/* Video Modal */}
      {isModalOpen && data.video && (
        <div className="fixed inset-0 z-[999999] bg-teal flex items-center justify-center">
          <div className="relative bg-teal p-4 rounded-lg w-full h-full flex justify-center items-center">
            <div className="w-full lg:w-container">
              <button
                onClick={closeModal}
                className="absolute top-4 xl:top-[5%] 2xl:right-[10%] xl:right-[5%] sm:right-4 right-4 text-black font-bold bg-[#8DC63F] rounded-full"
              >
                <svg
                  width="33"
                  height="33"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="sm:w-[55px] sm:h-[55px]"
                >
                  <circle cx="31.6743" cy="31.5591" r="31.5591" fill="#8DC63F" />
                  <path
                    d="M20.7722 20.6592L42.5726 42.4596"
                    stroke="black"
                    strokeWidth="3.64314"
                    strokeLinecap="round"
                  />
                  <path
                    d="M42.573 20.6592L20.7726 42.4596"
                    stroke="black"
                    strokeWidth="3.64314"
                    strokeLinecap="round"
                  />
                </svg>
              </button>

              <div className="2xl:h-[600px] xl:h-[470px] lg:h-[370px] h-[450px] w-full">
                <iframe
                  src={data.video}
                  frameBorder="0"
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowFullScreen
                  className="h-full w-full object-cover"
                  title="buddha mentors video"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default SuccessStories;
